import qs from 'qs'
import request from './base'
const requireContext = require.context('.', false, /\.js$/)
let services = {}

const regex = /^\/|\/$/g

requireContext.keys().forEach(file => {
  if (file === './index.js' || file === './base.js') return
  services = { ...services, ...requireContext(file).default }
})

const requireApi = require.context('@/api', false, /\.js$/)
let methods = {}
let generatorVuex = {}
requireApi.keys().forEach(file => {
  let apiObject = requireApi(file).default
  let fileName = file.replace(/\.\/|\.js$/g, '')
  let _methods = {}
  let tempVuex = {}
  for (let item of apiObject) {
    let { url, method, argsParams, baseURL, headers, formdata, showLoading } = item.options
    let vuex = item.vuex
    method = (method || 'get').toLowerCase()
    let methodName = url.replace(regex, '').replace(/[\W|_]([a-zA-Z])/g, (_, letter) => {
      return letter.toUpperCase()
    })

    if (methodName in _methods) {
      methodName = `${method}${methodName.substring(0, 1).toUpperCase()}${methodName.substring(1)}`
    }
    _methods[methodName] = (commit, payload, mutation) => {
      let options = {}
      let _url = `/${url.replace(regex, '')}`
      if (argsParams) {
        _url = `${_url}/${payload.id || payload}`
      }
      options.url = _url
      let _payload = payload
      let payloadHeaders = null
      if (payload && payload.headers) {
        const { headers: _payloadHeaders, ...otherPayload } = payload || {}
        payloadHeaders = _payloadHeaders
        _payload = otherPayload
      }

      let data = {}
      let params = {}

      if (_payload) {
        if (_payload.params) {
          params = _payload.params
        }

        const isFormData = _payload && `${_payload.data || _payload}`.toString() === '[object FormData]'

        const isArray = Array.isArray(_payload)

        if (isFormData) {
          data = _payload.data || _payload
        } else if (isArray) {
          data = _payload
        } else {
          const { params: _, ...other } = _payload

          if (other.data !== undefined && Object.keys(other).length === 1) {
            data = other.data
          } else {
            data = other
          }
        }

        if (method === 'get' && !argsParams && !isFormData && !isArray) {
          options.params = { ...data }
          data = {}
        }
      }

      if (Object.keys(params).length) {
        options.params = params
      }

      if (baseURL) {
        options.baseURL = `/${baseURL.replace(regex, '')}`
      }

      options = { ...item.options, ...options }
      let isFormData = false
      let isArrayData = false
      if (data) {
        isFormData = `${data}`.toString() === '[object FormData]'
        isArrayData = Array.isArray(data)
      }

      // POST 请求即使载荷为空对象({})也应挂 data(发送空 body),否则后端收不到 body 返回 400
      if (isFormData || (data && (isArrayData || Object.keys(data).length)) || (method === 'post' && data !== undefined && data !== null)) {
        if (!isFormData && formdata && !isArrayData) {
          data = qs.stringify(data)
        }
        options = { data, ...options }
      }

      if (headers) {
        options = { ...options, headers }
      }
      if (payloadHeaders) {
        options.headers = { ...options.headers, ...payloadHeaders }
      }

      if (showLoading) {
        options.showLoading = showLoading
      }

      return request.base(commit, options, mutation)
    }
    if (vuex || (vuex !== false && method === 'get')) {
      let _mutationType = url.replace(regex, '').replace(/\W/g, '_').toUpperCase()
      let state = (vuex && vuex.state) || _mutationType
      let getter = (vuex && vuex.getter) || _mutationType
      let mutationType = (vuex && vuex.mutationType) || _mutationType
      tempVuex[methodName] = {
        _state: state,
        getter,
        mutationType
      }
    }
  }
  methods[fileName] = _methods
  generatorVuex[fileName] = tempVuex
})
services = { ...methods, ...services }

export {
  methods,
  generatorVuex
}

export default services



// WEBPACK FOOTER //
// ./src/services/index.js